export default __webpack_public_path__ + "static/media/minus-circle-outline.6f284072.svg";